import { takeEvery, takeLatest } from 'redux-saga/effects';
import { fetchFiltersRequestVPO } from '../store/filters/filters';
import { handleFetchFiltersVPO } from '../store/filters/saga';
import { fetchDataMainRequestVPO, createAnswerRequestVPO, updateAnswerRequestVPO, fetchActionsOnlyRequestVPO, createQuestionnaireRequestVPO, updateQuestionnaireRequestVPO, toggleAuditRequestVPO, createOrUpdateAuditRequestVPO } from '../store/data-main/data-main';
import { handleFetchDataMainVPO, handleCreateAnswerVPO, handleUpdateAnswerVPO, fetchActionsOnlySagaVPO, handleCreateQuestionnaireVPO, handleUpdateQuestionnaireVPO, handleToggleAuditVPO, handleCreateOrUpdateAuditVPO } from '../store/data-main/saga';
import { fetchDataSummaryRequestVPO } from '../store/data-summary/data-summary';
import { handleFetchDataSummaryVPO } from '../store/data-summary/saga';
import { fetchReportFactoryRequestVPO } from '../store/report-factory/report-factory';
import { handleFetchReportFactoryVPO } from '../store/report-factory/saga';
import { fetchColumnsRequest } from '../store/columns/columns';
import { handleFetchColumns } from '../store/columns/saga';
import { fetchCurrentDateRequestVPO } from '../store/date/date';
import { handleFetchCurrentDateVPO } from '../store/date/saga';
import { fetchSettingsRequest } from '../store/settings/settings';
import { handleFetchSettings } from '../store/settings/saga';
import { StrapiActionTypes } from '../types/strapiVPO';
import { fetchDataSagaVPO } from '../store/filtersData/saga';
import {
  addDataVPOSaga,
  addDataSuccessVPOSaga,
  updateDataVPOSaga,
  deleteDataVPOSaga,
  fetchActionByContextSaga,
  fetchInconsistenciesByActionIdSaga
} from '../store/formAddActions/saga';
import { VPOCombinedActionsTypes } from '../store/vpoCombinedActions/actions';
import { fetchVPOCombinedActionsSaga } from '../store/vpoCombinedActions/saga';
import { FETCH_REPORTS_REQUEST } from '../store/reports/actions';
import { fetchReportsSaga } from '../store/reports/saga';
import { VPOReportCompletedActionsTypes } from '../store/vpoReportCompletedActions/actions';
import { fetchVPOReportCompletedActionsSaga } from '../store/vpoReportCompletedActions/saga';

export function* vpoWatcherStrapi() {
  yield takeLatest(fetchFiltersRequestVPO.type, handleFetchFiltersVPO);
  yield takeLatest(fetchColumnsRequest.type, handleFetchColumns);
  yield takeLatest(fetchCurrentDateRequestVPO.type, handleFetchCurrentDateVPO);
  yield takeLatest(fetchSettingsRequest.type, handleFetchSettings);
  yield takeLatest(fetchDataMainRequestVPO.type, handleFetchDataMainVPO);
  yield takeLatest(fetchDataSummaryRequestVPO.type, handleFetchDataSummaryVPO);
  yield takeLatest(fetchReportFactoryRequestVPO.type, handleFetchReportFactoryVPO);
  yield takeLatest(createAnswerRequestVPO.type, handleCreateAnswerVPO);
  yield takeLatest(updateAnswerRequestVPO.type, handleUpdateAnswerVPO);
  yield takeLatest(createQuestionnaireRequestVPO.type, handleCreateQuestionnaireVPO);
  yield takeLatest(updateQuestionnaireRequestVPO.type, handleUpdateQuestionnaireVPO);
  yield takeEvery(fetchActionsOnlyRequestVPO.type, fetchActionsOnlySagaVPO);
  yield takeLatest(toggleAuditRequestVPO.type, handleToggleAuditVPO);
  yield takeLatest(createOrUpdateAuditRequestVPO.type, handleCreateOrUpdateAuditVPO);
  yield takeEvery(StrapiActionTypes.FETCH_REQUEST_VPO, fetchDataSagaVPO);
  yield takeEvery(StrapiActionTypes.ADD_REQUEST_VPO, addDataVPOSaga);
  yield takeEvery(StrapiActionTypes.ADD_SUCCESS_VPO, addDataSuccessVPOSaga);
  yield takeEvery(StrapiActionTypes.UPDATE_REQUEST_VPO, updateDataVPOSaga);
  yield takeEvery(StrapiActionTypes.DELETE_REQUEST_VPO, deleteDataVPOSaga);
  yield takeEvery(StrapiActionTypes.FETCH_ACTION_BY_CONTEXT_REQUEST_VPO, fetchActionByContextSaga);
  yield takeEvery(StrapiActionTypes.FETCH_INCONSISTENCIES_BY_ACTION_REQUEST_VPO, fetchInconsistenciesByActionIdSaga);
  yield takeEvery(VPOCombinedActionsTypes.FETCH_REQUEST, fetchVPOCombinedActionsSaga);
  yield takeLatest(FETCH_REPORTS_REQUEST, fetchReportsSaga);
  yield takeEvery(VPOReportCompletedActionsTypes.FETCH_REQUEST, fetchVPOReportCompletedActionsSaga);
}
